<template>
    <section>
        <div class="contract">
            <div v-if="loader.body" class="loading">
                <ui-load-indicator :h="50" :stroke="8" bg-color="#e7e9f4" color="#69D296" />
            </div>

            <div v-else>
                <div v-if="data.length" class="list-contracts scroll-color">
                    <div class="top accordion-bar">
                        Nome
                    </div>
                    <ui-accordion-multiple
                        v-for="(item, index) in data"
                        :key="index"
                        :active="openContent == index"
                        :set="index"
                        :loading="item.loading"
                        title="Nome"
                        set-button
                        @input="active($event, index)"
                    >
                        <template #action>
                            {{ item.title }}
                        </template>
						
                        <template #button>
                            <div :class="{ actions: isCancelled(item.data) && contractsFeaturesIsAllowed }">
                                <ui-info-tag
                                    v-if="item.situation == 'Assinado'"
                                    option-class="sm success"
                                >
                                    {{ item.situation }}
                                </ui-info-tag>
                                <ui-info-tag
                                    v-else-if="
                                        item.situation != 'Não iniciado' &&
                                            item.situation != 'Cancelado' &&
                                            item.situation != 'Rejeitado' &&
                                            item.situation !== 'Criado'
                                    "
                                    option-class="sm grey"
                                >
                                    {{ item.situation }}
                                </ui-info-tag>
                                <ui-info-tag
                                    v-else-if="
                                        item.situation == 'Cancelado' ||
                                            item.situation == 'Rejeitado'
                                    "
                                    option-class="sm danger"
                                >
                                    {{ item.situation }}
                                </ui-info-tag>
                                <div v-else-if="enableSend(item.data) || contractsFeaturesIsAllowed">
                                    <ui-button
                                        v-if="contractsFeaturesIsAllowed && enableSend(item.data)"
                                        :loading="item.loading"
                                        design="line-primary xs"
                                        @click="send(item)"
                                    >
                                        {{
                                            item.data?.integration_slug === 'assine_online'
                                                ? 'Iniciar Fluxo'
                                                : 'Enviar Envelope'
                                        }}
                                    </ui-button>
                                    <ui-info-tag
                                        v-else-if="enableSend(item.data)"
                                        option-class="sm grey"
                                    >
                                        {{ item.situation }}
                                    </ui-info-tag>
                                </div>
                            </div>
                            <ui-menu-card
                                v-if="!isCancelled(item.data) && contractsFeaturesIsAllowed"
                                fixed
                                style-options
                            >
                                <!-- <button
									@click="selectSigners(item.data)"
									v-if="getFlowType(item.data) == 'template'"
								>
									Selecionar Assinantes
								</button> -->
                                <button
                                    v-if="getFlowType(item.data) === 'workflow'"
                                    @click="flowStatus(item)"
                                >
                                    Verificar status de assinaturas
                                </button>
                                <button
                                    v-if="canDelete(item.data)"
                                    @click="deleteFlow(item.data)"
                                >
                                    {{ getDeleteLabel(item.data) }}
                                </button>
                            </ui-menu-card>
                        </template>

                        <template v-if="item.files?.length" #content>
                            <div class="content-title">Contratos deste fluxo:</div>
                            <div class="content">
                                <div
                                    v-for="(contract, i) in item.files"
                                    :key="i"
                                    class="content-item"
                                >
                                    <div class="infos">
                                        <div class="icon">
                                            <i class="fal fa-file"/>
                                        </div>
                                        {{ contract.title }}
                                    </div>
                                    <ui-menu-card fixed style-options>
                                        <button
                                            v-if="contractsFeaturesIsAllowed && contract.historic"
                                            @click="historyHandler(contract.historic)"
                                        >
                                            Histórico
                                        </button>
                                        <button
                                            v-if="[6, 'closed', 'completed'].includes(item.data.status)"
                                            @click="downloadHandler(contract.download)"
                                        >
                                            Baixar
                                        </button>
                                    </ui-menu-card>
                                </div>
                            </div>
                        </template>
                    </ui-accordion-multiple>
                </div>

                <div v-else class="loading">
                    <small>Não há dados para exibir.</small>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiMenuCard, uiInfoTag, uiLoadIndicator } from '@/components/ui'
	import { uiAccordionMultiple } from '@/components/ui/accordion'

	import { digitalSignature } from '@/services/axios'

	import { mapGetters } from 'vuex'

	const defaultLoader = () => ({
		body: false,
	})

	export default {
		name: 'subscribs-flows',

		components: {
			uiButton,
			uiMenuCard,
			uiInfoTag,
			uiLoadIndicator,
			uiAccordionMultiple,
		},

		props: {
			dealId: {
				type: Number,
				default: undefined,
			},
			/**
			 * Dados dos fluxos cadastrados no sistema
			 */
			data: {
				type: Array,
				required: true
			}
		},

		data() {
			return {
				openContent: 0,
				allChecked: false,
				newItem: null,
				loader: { ...defaultLoader() },
				contractsFeaturesIsAllowed: false,
			}
		},

		computed: {
			...mapGetters('digitalSignatureStore', {
				integration: 'getIntegration'
			})
		},

		async mounted() {
			this.$root.$on('contracts-features-is-allowed', (bool) => {
				// Verify if user_group is allowed to use contracts features
				this.contractsFeaturesIsAllowed = bool
			})

			this.$root.$on('deal-flow-list-load', payload => {
				this.loader.body = payload
			})
		},

		beforeDestroy() {
			this.$root.$off('contracts-features-is-allowed')
			this.$root.$off('deal-flow-list-load')
		},

		methods: {
			/**
			 * Ativa um dos accordion e caso seja um fluxo DocuSign ou ClickSign, busca os
			 * arquivos
			 */
			active(set, index) {
				this.openContent = this.openContent === set ? null : set

				/**
				 * Para as integrações DocuSign e ClickSign, busca-se os arquivos na rota
				 * documents
				 */
				const item = this.data[index]
				if (['docu_sign', 'click_sign'].includes(item?.data?.integration_slug) &&
					!item?.files?.length) {
					this.data[index].loading = true
					const params = {
						integration_id: this.integration?.id,
						signature_id: item?.data.signature_id
					}

					digitalSignature.getAllV2('documents', params)
						.then(response => {
							this.data[index].files = response.data?.data?.length
								? Object.values(response.data.data).map(file => ({
									title: file.name,
									historic: file.docIdHref || '',
									download: file.link?.signed || file.link?.original
								}))
								: []
						})
						.catch(error => {
							if (error?.data?.msg) this.$toastr.e(error.data.msg)
							console.log(error)
						})
						.finally(() => {
							this.data[index].loading = false
						})
				}

				// Emite o evento do Google Analytics
				this.$gtm.trackEvent({
					event: 'fac_button_click',
					category: 'vue-contratos-deste-fluxo',
					action: 'click',
					label: 'Contratos deste Fluxo'
				})
			},

			open() {
				this.openContent = !this.openContent
				this.$emit('emit')
			},

			getFlowType(item) {
				return item.flowType
			},

			async deleteFlow(item) {
				// Emite o evento do Google Analytics
				let category = 'vue-excluir-fluxo'
				let label = 'Excluir Fluxo'
				if (this.getFlowType(item) !== 'template') {
					category = 'vue-cancelar-fluxo'
					label = 'Cancelar Fluxo'
				}
				this.$gtm.trackEvent({ event: 'fac_button_click', category, action: 'click', label })

				// Show loading warning
				this.$root.$emit('contracts-loading-warning', true)

				try {
					const params = `?signature_id=${item.signature_id}&integration_id=${this.integration?.id}`
					const { data } = await digitalSignature.deleteV2('cancel', params)

					// Show request infos
					if (data.status === 'success') this.$toastr.s(data.msg)
					else this.$toastr.w(data.msg)

					// Refresh list
					this.$emit('reload')
				} catch (error) {
					console.log(error)
				}

				// Disable loading warning
				this.$root.$emit('contracts-loading-warning', false)
			},

			getDeleteLabel(item) {
				return this.getFlowType(item) === 'template' ? 'Excluir Fluxo' : 'Cancelar Fluxo'
			},

			isCancelled(item) {
				return item.status == 2 ? true : false
			},
			/**
			 * Recebe um fluxo/envelope e inicia-o/envia-o
			 */
			send(item) {
				// Emite o evento do Google Analytics
				this.$gtm.trackEvent({
					event: 'fac_button_click',
					category: 'vue-assinar-digitalmente',
					action: 'click',
					label: 'Assinar Digitalmente'
				})

				if (item?.data?.integration_slug === 'assine_online') {
					const fullPath = item.data.url +
						'=&callbackUrl=' +
						window.location.protocol +
						'//' +
						window.location.host +
						'/vendas/negocios/' +
						this.dealId +
						'?forceCache=true'
					window.open(fullPath)

				} else {
					// Atualiza o status de um envelope e o envia
					item.loading = true
					const params = {
						status: 'sent',
						signature_id: item?.data?.signature_id,
						integration_id: this.integration?.id
					}
					digitalSignature.createV2('workflow', params)
						.then(response => {
							if (response?.data?.msg) this.$toastr.s(response.data.msg)
						})
						.catch(error => {
							if (error?.data?.msg) this.$toastr.s(error.data.msg)
							console.log(error)
						})
						.finally(() => {
							item.loading = false
						})
				}
			},

			openIframe(value, data = null) {
				let event = new CustomEvent(`iframe--contracts-${value}`, { detail: data })
				window.parent.document.dispatchEvent(event)
			},

			flowStatus(item) {
				// Emite o evento do Google Analytics
				this.$gtm.trackEvent({
					event: 'fac_button_click',
					category: 'vue-verificar-assinaturas',
					action: 'click',
					label: 'Verificar Assinaturas'
				})

				let data = []
				const documents = [...item.files]

				// Not have documents
				if (!documents.length) return

				documents.forEach(document => {
					// Not have signer status
					if (!document.workflowSteps.length) return

					// Input signers status
					let steps = []
					document.workflowSteps.forEach((step) => {
						steps.push({
							status: step.status,
							name: step._embedded.user.name,
							group: step._embedded.user.email,
						})
					})

					// Format data
					data.push({
						docName: document.title,
						status: steps,
					})
				})

				this.openIframe('status', data)
			},
			/**
			 * Emite um evento para recarregar a lista de fluxos do negócio
			 */
			reload() {
				setTimeout(() => {
					this.$emit('reload')
				}, 500)
			},
			/**
			 * Event handler para quando o histórico for acessado
			 */
			historyHandler(history) {
				// Emite o evento do Google Analytics
				this.$gtm.trackEvent({
					event: 'fac_button_click',
					category: 'vue-historico-fluxo',
					action: 'click',
					label: 'Histórico do Fluxo'
				})
				window.open(history, '_blank')
			},
			/**
			 * Event handler para quando o download de um contrato Assinado for solicitado
			 */
			downloadHandler(download) {
				window.open(download)
			},
			/**
			 * Verifica se o botão de enviar está ativado para determinado fluxo/envelope
			 */
			enableSend(item) {
				return (item.status === 200 || item.status === 'created') &&
					['assine_online', 'docu_sign'].includes(item.integration_slug)
			},
			/**
			 * Verifica se um fluxo/envelope pode ser removido conforme o tipo de assinatura
			 */
			canDelete(item) {
				let can = false
				switch (item.integration_slug) {
					case 'assine_online':
						can = item.status !== 6
						break

					case 'click_sign':
						can = item.status === 'draft'
						break
				}

				return can
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
